import { applicableLicenseKinds, LICENSE_LABELS } from '../../../utils/licenseRelevance.generated';
import { matchStateCode, matchStateName } from '../../../utils/usStates';

export const LICENSE_REQUIREMENT_OPTIONS = [
  { value: 'required', label: 'Required' },
  { value: 'not_required', label: 'Not required' },
  { value: 'unknown', label: 'Not specified' },
];

export function listingLicenseContext(value = {}) {
  const state = matchStateCode(String(value.location || '').split(',').pop().trim());
  const kinds = applicableLicenseKinds(value.providerType || value.section);
  const previousState = matchStateCode(value.licenseRequirementsState);
  const stateChanged = !!previousState && previousState !== state;
  const scopeMissing = !previousState && Object.keys(value.licenseRequirements || {}).length > 0;
  return {
    state, stateName: matchStateName(state), previousState, stateChanged, scopeMissing, kinds,
    requirements: stateChanged || !previousState ? {} : value.licenseRequirements || {},
  };
}

export function licenseRequirementPills(value) {
  const context = listingLicenseContext(value);
  if (!context.state || !context.kinds.length) return [];
  if (context.stateChanged || context.scopeMissing) return [`Review ${context.state} licenses`];
  return context.kinds.filter((kind) => context.requirements[kind]).map((kind) =>
    `${context.state} ${LICENSE_LABELS[kind]} ${context.requirements[kind] === 'required' ? 'required' : context.requirements[kind] === 'not_required' ? 'not required' : 'not specified'}`,
  );
}
